// is this really better than normal case? Have to-remap in components for TS
export enum SubjectRegisterMutations {
  RESET = "RESET",
  SET_SUBJECT = "SET_SUBJECT",
  SET_SUBJECTS = "SET_SUBJECTS",
}
